import { Box, Image } from '@chakra-ui/react'
import React from 'react'

export const FreeHomeDelivery = () => {
  return (
    <Box display={{base: 'block', md: 'none'}} mb='20px'>
        <Image maxHeight='70px' w='100%' src='#'></Image>
    </Box>
  )
}
